<template>
    <div>
        <div class="showData">
        {{totalItems}}件 資金: {{totalCapital}}円 優待総額: {{totalIncentiveValue}}円 総費用: {{totalCost}}円 売却利益: {{totalProfit}}円
        </div>
        <v-data-table
            dense
            :headers="headers"
            :items="UserIncentives"
            :search="search"
            :items-per-page=50
            :footer-props="{
                'items-per-page-options': [10, 20, 50, 100, 200, 300, 400, 500],
                showFirstLastPage: true,
            }"
            multi-sort
            ref="refTable"
            @current-items="currentItems"
            class="elevation-1">

            <template v-slot:top>
                <v-toolbar flat color="gray">
                    <v-toolbar-title>優待取得状況一覧</v-toolbar-title>
                    <v-divider
                        class="mx-3"
                        inset
                        vertical></v-divider>
                    <v-icon @click="refresh()">refresh</v-icon>
                    <v-spacer></v-spacer>

                    <v-text-field
                            v-model="nameFilterValue"
                            append-icon="search"
                            label="銘柄名検索"
                            single-line
                            hide-details></v-text-field>

                    <v-text-field
                            v-model="dateFilterValue"
                            append-icon="search"
                            label="日付検索"
                            single-line
                            hide-details></v-text-field>

                    <v-text-field
                            v-model="holderFilterValue"
                            append-icon="search"
                            label="名義検索"
                            single-line
                            hide-details></v-text-field>

                    <v-text-field
                            v-model="incentiveFilterValue"
                            append-icon="search"
                            label="優待検索"
                            single-line
                            hide-details></v-text-field>

                    <!-- ユーザ追加ボタン フォームは下部 -->
                    <v-btn fab dark small color="dark" class="mb-2"
                        @click="dialog=true"
                    >
                        <v-icon dark>add</v-icon>
                    </v-btn>

                    <v-dialog v-model="dialog" max-width="700px">
                        <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <StockCodeAutocomplete
                                            @updateStockName="updateStockName"></StockCodeAutocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.code" label="コード"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-menu v-model="menu" max-width="290px" min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="editedItem.right_allotment_date"
                                                    label="権利取得日"
                                                    @change="updateStockPrice"
                                                    v-on="on"/>
                                            </template>
                                            <v-date-picker
                                                v-model="editedItem.right_allotment_date"
                                                @change="updateStockPrice"
                                                :scrollable=true
                                                :noTitle=true
                                                locale="jp-ja"/>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.right_allotment_price" label="権利取得日株価"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.right_loss_price" label="権利落ち日株価"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.allotment_num" label="取得数"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.incentive" label="優待品"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.incentive_value" label="優待価値"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.holder_name" label="名義"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.holder_number" label="株主番号"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select
                                            label="会社"
                                            :items="Companies"
                                            item-text="name"
                                            item-value="id"
                                            v-model="editedItem.company_id"
                                            required></v-select>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="editedItem.transaction_fee" label="買手数料"></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="editedItem.interest_buy" label="金利"></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="editedItem.transaction_fee_sell" label="売手数料"></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="editedItem.interest_sell" label="金利"></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="editedItem.backwordation" label="逆日歩"></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="editedItem.dividend" label="配当金"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select
                                            label="取引区分"
                                            :items="TransactionTypes"
                                            item-text="text"
                                            item-value="value"
                                            v-model="editedItem.transaction_type"
                                            required></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select
                                            label="長期優待有無"
                                            :items="Answer"
                                            item-text="text"
                                            item-value="value"
                                            v-model="editedItem.is_long_term_incentive"
                                            required></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select
                                            label="端株取得有無"
                                            :items="Answer"
                                            item-text="text"
                                            item-value="value"
                                            v-model="editedItem.is_odd_lot_holding"
                                            required></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-menu v-model="menu2" max-width="290px" min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="editedItem.incentive_recieve_date"
                                                    label="優待受取日"
                                                    v-on="on"/>
                                            </template>
                                            <v-date-picker v-model="editedItem.incentive_recieve_date" :scrollable=true :noTitle=true locale="jp-ja"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-menu v-model="menu3" max-width="290px" min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="editedItem.expiration_date"
                                                    label="優待有効期限"
                                                    v-on="on"/>
                                            </template>
                                            <v-date-picker v-model="editedItem.expiration_date" :scrollable=true :noTitle=true locale="jp-ja"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.remain" label="優待残額"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.auction_profit" label="売却利益"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                        </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-toolbar>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)">
                    mdi-pencil
                </v-icon>
                <v-icon
                    small
                    @click="deleteItem(item)">
                    mdi-delete
                </v-icon>
            </template>

            <template v-slot:item.profitability="{ item }">
                <v-chip :color="getColor(item.profitability)" dark>{{ item.profitability }}</v-chip>
            </template>

            <template v-slot:item.used="{ item }">
                <v-chip :color="getColor(item.used)" dark>{{ item.used }}</v-chip>
            </template>

            <template v-slot:item.name="{ item }">
                {{ item.name }}<br/><ExternalLinks :code="item.code" />
            </template>

        </v-data-table>

        <v-snackbar
            v-model="snackbar"> {{ snacktxt }}
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios';
import StockCodeAutocomplete from "../components/StockCodeAutocomplete";
import ExternalLinks from "../components/ExternalLinks";

export default {
    data () {
        return {
            UserIncentives: [],
            Companies: [],
            TransactionTypes: [
                { text: "現物", value: "cash" },
                { text: "制度信用", value: "seido_mergin" },
                { text: "一般信用", value: "gen_mergin" },
            ],
            Answer: [
                { text: "有", value: "yes" },
                { text: "無", value: "no" },
            ],
            search: '', // フィルタリング検索キーワード
            nameFilterValue: '',
            dateFilterValue: '',
            holderFilterValue: '',
            incentiveFilterValue: '',
            dialog: false,
            menu: false,
            menu2: false,
            menu3: false,
            editedIndex: -1,
            editedItem: {"allotment_num" : 100, "holder_name" : "自分", "transaction_fee" : 0, "interest_buy" : 0,
                        "transaction_fee_sell" : 0, "interest_sell" : 0, "backwordation" : 0,
                        "dividend" : 0, "is_long_term_incentive" : "no", "is_odd_lot_holding" : "no"},
            snackbar: false,
            snacktxt: "",
            userId: 0,
            totalItems: 0,
            totalCapital: 0,
            totalIncentiveValue: 0,
            totalCost: 0,
            totalProfit: 0,
            filteredItems: [],
        }
    },
    components: {
        StockCodeAutocomplete,
        ExternalLinks,
    },
    computed: {
        formTitle () {
            return this.editedIndex === -1 ? '新規追加' : '編集'
        },
        headers () {
            return [
                { text: "コード", align: 'start', value: "code" },
                { text: "銘柄名", value: 'name', filter: this.nameFilter },
                { text: "取得数", value: 'allotment_num' },
                { text: "株価", value: 'right_allotment_price' },
                { text: "取得日", value: 'right_allotment_date', filter: this.dateFilter },
                { text: "名義", value: 'holder_name', filter: this.holderFilter },
                { text: "優待価値", value: 'incentive_value' },
                { text: "売却利益", value: 'auction_profit' },
                { text: "利益率", value: 'profitability' },
                { text: "費用", value: 'cost' },
                { text: "優待", value: 'incentive', filter: this.incentiveFilter },
                { text: "期限", value: 'expiration_date' },
                { text: "受取日", value: 'incentive_recieve_date' },
                { text: "済", value: 'used' },
                { text: "操作", align: 'center', value: 'actions', sortable: false }
            ]
        },
    },
    methods: {
        nameFilter (value)  {
            if (!this.nameFilterValue) {
                return true;
            }
            return value.includes(this.nameFilterValue);
        },
        dateFilter (value) {
            if (!this.dateFilterValue) {
                return true;
            }
            return value.includes(this.dateFilterValue);
        },
        holderFilter (value) {
            if (!this.holderFilterValue) {
                return true;
            }
            return value === this.holderFilterValue;
        },
        incentiveFilter (value) {
            if (!this.incentiveFilterValue) {
                return true;
            }
            return value.includes(this.incentiveFilterValue)
        },
        updateStockName (value) {
            this.editedItem.code = value.slice(0,4);
            axios
                .get('/api/v1/incentives/'+this.editedItem.code)
                .then(response => {
                    this.$set(this.editedItem,'incentive',response.data.summary);
                    this.$set(this.editedItem,'incentive_value',response.data.incentive_price);
                });
        },
        updateStockPrice () {
            axios
                .get('/api/v1/histories/'+this.editedItem.code+'/'+this.editedItem.right_allotment_date)
                .then(response => {
                    this.$set(this.editedItem,'right_allotment_price',response.data[0].end);
                    this.$set(this.editedItem,'right_loss_price',response.data[1].start);
                });
        },
        setUserId () {
            this.userId=this.UserIncentives[0].user_id;
        },
        indexUserIncentives () {
            this.UserIncentives = [];
            axios
                .get('/api/v1/user_incentives')
                .then(response => {
                    this.UserIncentives=response.data;
                });
        },
        indexCompanies () {
            this.Companies = [];
            axios
                .get('/api/v1/companies')
                .then(response => {
                    this.Companies=response.data;
                });
        },
        refresh (){
           this.indexUserIncentives();
        },
        editItem (item) {
            this.editedIndex = this.UserIncentives.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog=true;
            console.log("editItem");
        },
        deleteItem (item) {
            console.log("deleteItem");
        },
        currentItems: function(value){
            this.filteredItems = value;
            this.totalItems = this.filteredItems.length.toLocaleString();
            this.totalCapital = this.filteredItems.reduce((p,x) => Number(p) + Number(x.right_allotment_price*x.allotment_num), 0).toLocaleString();
            this.totalIncentiveValue = this.filteredItems.reduce((p,x) => Number(p) + Number(x.incentive_value), 0).toLocaleString();
            this.totalCost = this.filteredItems.reduce((p,x) => Number(p) + Number(x.cost), 0).toLocaleString();
            this.totalProfit = this.filteredItems.reduce((p,x) => Number(p) + Number(x.auction_profit), 0).toLocaleString();
        },
        save () {
            let errflag=false;
            this.editedItem.user_id=this.UserIncentives[0].user_id;
            axios.post('/api/v1/user_incentives',this.editedItem).catch( function (error) {
                if(error.response) {
                    console.log("ERROR!");
                    errflag=true;
                }
            });
            if(errflag==true){
                this.snacktxt="エラーが発生しました";
                this.snackbar=true;
                this.close();
                return;
            }

            if (this.editedIndex > -1) {
                Object.assign(this.UserIncentives[this.editedIndex], this.editedItem);
            } else {
                this.UserIncentives.push(this.editedItem);
            }
            this.snacktxt="正常に更新されました";
            this.snackbar=true;
            this.close();
        },
        close () {
            this.dialog = false
            this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            });
        },
        getColor (value) {
            if (value > 1.0 || value == "未" ) return 'red'
            else return 'green'
        }
    },
    mounted () {
        this.indexUserIncentives();
        this.indexCompanies();
    }
}
</script>

<style>
.showData {
    font-size: 24px;
    font-weight: bold;
}
</style>